"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _prefix = _interopRequireDefault(require("../../prefix"));

var _ControlLabel = _interopRequireDefault(require("react-bootstrap/lib/ControlLabel"));

var _classnames = _interopRequireDefault(require("classnames"));
/**
 * Label is a wrapper of ControlLabel that applies a className-label class
 * and adds a class of fieldIsRequired if required is true.
 *
 * Passing extra props to ControlLabel may break the classNames applied to the label
 */


var Label = function Label(_ref) {
  var htmlId = _ref.htmlId,
      required = _ref.required,
      className = _ref.className,
      children = _ref.children,
      htmlFor = _ref.htmlFor;
  var classList = className ? className.split(" ") : [];
  classList = classList.map(function (value) {
    return value.trim() ? "".concat(value, "-label") : "";
  });

  if (required) {
    classList.push("control-label--required");
  }

  return /*#__PURE__*/_react["default"].createElement(_ControlLabel["default"], {
    bsClass: (0, _classnames["default"])(classList, "".concat(_prefix["default"], "control-label")),
    id: htmlId,
    htmlFor: htmlFor
  }, children);
};

var _default = Label;
exports["default"] = _default;